import React from "react";
import { useEffect, useState } from "react";
import { firestore } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import "../scss/Scss/Home.scss";
import { Link } from "react-router-dom";

function Aboutpage() {
  const [dataCIWEB, setDataCIWEB] = useState(null);
  const [dataCISafetyEdit, setDataCISafetyEdit] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const docRefCIWEB = doc(firestore, "CI WEB", "Home");
    const docRefCISafetyEdit = doc(firestore, "CI WEB - SAFETY EDIT", "Home");

    const fetchDataCIWEB = async () => {
      try {
        const docSnapshot = await getDoc(docRefCIWEB);
        if (docSnapshot.exists()) {
          setDataCIWEB(docSnapshot.data());
        } else {
          console.log("No such document for CI WEB!");
        }
      } catch (error) {
        console.error("Error fetching document for CI WEB:", error);
      }
    };

    const fetchDataCISafetyEdit = async () => {
      try {
        const docSnapshot = await getDoc(docRefCISafetyEdit);
        if (docSnapshot.exists()) {
          setDataCISafetyEdit(docSnapshot.data());
        } else {
          console.log("No such document for CI WEB - SAFETY EDIT!");
        }
      } catch (error) {
        console.error(
          "Error fetching document for CI WEB - SAFETY EDIT:",
          error
        );
      }
    };

    fetchDataCIWEB();
    fetchDataCISafetyEdit();

    setIsMobile(window.innerWidth <= 1366);
    window.addEventListener("resize", () => {
      setIsMobile(window.innerWidth <= 1366);
    });

    return () => {
      window.removeEventListener("resize", () => {
        setIsMobile(window.innerWidth <= 1366);
      });
    };
  }, []);

  return (
    <>
      {dataCIWEB && dataCISafetyEdit && (
        <div className={`Home-About ${isMobile ? "Home-AboutMB" : ""}`}>
          {!isMobile ? (
            <div className="SubheadingAbout">
              <div className="text-SubheadingAbout">
                {dataCISafetyEdit.AboutSubheading1}
                <br />
                {dataCISafetyEdit.AboutSubheading2}
                <br />
                {dataCISafetyEdit.AboutSubheading3}
                <br />
                {dataCISafetyEdit.AboutSubheading4}
              </div>
              <Link to="/about" className="BtnAbout">
                ABOUT US
              </Link>
            </div>
          ) : (
            <div className="AllTextBtnsAbout">
              <div className="SubheadingAboutMB">
                <div className="text-SubheadingAboutMB">
                  <div>{dataCISafetyEdit.AboutSubheading1}</div>
                  <div>{dataCISafetyEdit.AboutSubheading2}</div>
                  <div>{dataCISafetyEdit.AboutSubheading3}</div>
                  <div>{dataCISafetyEdit.AboutSubheading4}</div>
                </div>
                <Link to="/about" className="BtnAboutMB">
                  ABOUT US
                </Link>
              </div>
            </div>
          )}

          {!isMobile ? (
            <video
              loop
              muted
              autoPlay
              playsInline
              className="BgVideoAbout"
              style={{ pointerEvents: "auto" }}
              onContextMenu={(e) => e.preventDefault()}
            >
              <source
                src={dataCISafetyEdit.CIWEBHOMEABOUTNOTEXT}
                type="video/mp4"
              />
            </video>
          ) : (
            <div className="AllBgVideoAbout">
              <div className="SubBgVideoAbout">
                <video
                  loop
                  muted
                  autoPlay
                  playsInline
                  className="BgVideoAboutMB"
                  style={{ pointerEvents: "auto" }}
                  onContextMenu={(e) => e.preventDefault()}
                >
                  <source
                    src={dataCISafetyEdit.CIWEBHOMEABOUTNOTEXTMOBILE}
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
          )}

          {!isMobile ? (
            <img
              src={dataCIWEB.LogoGif}
              alt="My GIF"
              loading="lazy"
              className="LogoGif"
              onContextMenu={(e) => e.preventDefault()}
            />
          ) : null}

          {!isMobile ? (
            <div>
              <img
                className="Gifsticker1"
                src={dataCIWEB.Sticker1}
                alt="My GIF"
                loading="lazy"
                style={{ pointerEvents: "auto" }}
                onContextMenu={(e) => e.preventDefault()}
              />
              <img
                className="Gifsticker2"
                src={dataCIWEB.Sticker2}
                alt="My GIF"
                loading="lazy"
                style={{ pointerEvents: "auto" }}
                onContextMenu={(e) => e.preventDefault()}
              />
            </div>
          ) : (
            <div className="SubSticker">
              <img
                className="Gifsticker1MB"
                src={dataCIWEB.Sticker1}
                alt="My GIF"
                loading="lazy"
                style={{ pointerEvents: "auto" }}
                onContextMenu={(e) => e.preventDefault()}
              />
              <img
                className="Gifsticker2MB"
                src={dataCIWEB.Sticker2}
                alt="My GIF"
                loading="lazy"
                style={{ pointerEvents: "auto" }}
                onContextMenu={(e) => e.preventDefault()}
              />
            </div>
          )}

          {!isMobile ? (
            <div className="DescriptionAbout">
              <span className="text-DescriptionAbout">
                {dataCISafetyEdit.AboutDescription}
              </span>
            </div>
          ) : (
            <div className="SubDescriptionAbout">
              <div className="DescriptionAboutMB">
                <p className="text-DescriptionAboutMB">
                  {dataCISafetyEdit.AboutDescription}
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default Aboutpage;
